import BaseApi from './BaseApi';

class AuthApi extends BaseApi {
    check() {
        return this.requestGet(this.route('login.check'), null);
    }

    login(data) {
        const { email, password } = data || {};
        return this.requestPost(
            this.route('login'),
            {
                email,
                password,
            },
            {
                withCredentials: true,
            },
        );
    }

    signup(data) {
        return this.requestPost(this.route('signup'), data, {
            withCredentials: true,
        });
    }

    account(data) {
        return this.requestPost(this.route('pro.account.update'), data, {
            withCredentials: true,
        });
    }

    logout() {
        return this.requestPost(this.route('logout'), null, {
            withCredentials: true,
        });
    }

    requestConfirm(email) {
        return this.requestPost(
            this.route('email.confirmed.store'),
            { email },
            {
                withCredentials: true,
            },
        );
    }

    requestPassword(email) {
        return this.requestPost(
            this.route('password.request.store'),
            { email },
            {
                withCredentials: true,
            },
        );
    }

    resetPassword(data) {
        return this.requestPost(this.route('password.reset.store'), data, {
            withCredentials: true,
        });
    }
}

export default AuthApi;
